import { Action } from 'redux';
import { IProductDetails, IProductResult } from '../../services';

export interface IResultsState {
  showResultsPanel?: boolean;
  isLoading?: boolean;
  identification?: string;
  auctionResultsName?: string;
  auctionProductResults?: IProductResult[];
  errorMessage: string;
}

export enum ResultsActionEnum {
  ShowResultsPanel = '@@Result/Show_Results_Panel',
  HideResultsPanel = '@@Result/Hide_Results_Panel',
  FetchAuctionResults = '@@Result/Fetch_Auction_Results',
  FetchAuctionResultsSuccess = '@@Result/Fetch_Auction_Results_Success',
  FetchAuctionResultsFailed = '@@Result/Fetch_Auction_Results_Failed'
}

export interface IShowResultsPanelAction
  extends Action<typeof ResultsActionEnum.ShowResultsPanel> {
  state?: IResultsState;
}
export interface IHideResultsPanelAction
  extends Action<typeof ResultsActionEnum.HideResultsPanel> {
  state?: IResultsState;
}

export interface IFetchAuctionResultsAction
  extends Action<typeof ResultsActionEnum.FetchAuctionResults> {
  state?: IResultsState;
}

export interface IFetchAuctionResultsSuccessAction
  extends Action<typeof ResultsActionEnum.FetchAuctionResultsSuccess> {
  state?: IResultsState;
}

export interface IFetchAuctionResultsFailedAction
  extends Action<typeof ResultsActionEnum.FetchAuctionResultsFailed> {
  state?: IResultsState;
}

export type ResultsActions =
  | IShowResultsPanelAction
  | IHideResultsPanelAction
  | IFetchAuctionResultsAction
  | IFetchAuctionResultsSuccessAction
  | IFetchAuctionResultsFailedAction;
